import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import NetworkCapacity from "./NetworkCapacity";
import BiomassSection from "./BiomassSection";
import ProductsSection from "./ProductsSection";
// import FarmersSection from "./FarmersSection";
import TestimonialPage from "./FarmersSection";
import Footer from "../../components/common/Footer";

const UtpannProduction = () => {
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <HeroSection />
        <NetworkCapacity />
        <BiomassSection />
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default UtpannProduction;
